import { ImageOff } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface ProductImageViewProps {
  src?: string | undefined;
  alt: string;
  className?: string | undefined;
  imageClassName?: string | undefined;
  loading?: 'eager' | 'lazy' | undefined;
  sizes?: string | undefined;
  srcSet?: string | undefined;
}

export function ProductImageView({
  src,
  alt,
  className,
  imageClassName,
  loading = 'lazy',
  sizes,
  srcSet,
}: ProductImageViewProps): JSX.Element {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const hasImage = src !== undefined && !failed;

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
  }, [src]);

  return (
    <span
      className={cn(
        'relative flex shrink-0 items-center justify-center overflow-hidden rounded-md border border-border bg-muted/40',
        className,
      )}
    >
      {hasImage && !loaded ? (
        <Skeleton className="absolute inset-0 h-full w-full rounded-none" />
      ) : null}
      {hasImage ? (
        <img
          src={src}
          srcSet={srcSet}
          alt={alt}
          loading={loading}
          decoding="async"
          sizes={sizes}
          className={cn(
            'h-full w-full object-contain',
            imageClassName,
            loaded ? 'opacity-100' : 'opacity-0',
          )}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
        />
      ) : (
        <ImageOff className="h-5 w-5 text-muted-foreground" aria-hidden="true" />
      )}
    </span>
  );
}
